/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { AdminGetCourseDetailOptions, AdminGetCourseDetailStatus200, AdminGetCourseDetailStatus422 } from '../models/AdminGetCourseDetail'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { adminGetCourseDetail } from '../clients/axios/adminGetCourseDetail'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const adminGetCourseDetailQueryKey = ({ path }: Omit<AdminGetCourseDetailOptions, 'headers'>) => [{ url: '/admin/course/:course_id', params: path }] as const

type AdminGetCourseDetailQueryKey = ReturnType<typeof adminGetCourseDetailQueryKey>

export function adminGetCourseDetailQueryOptions({ path }: AdminGetCourseDetailOptions, config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = adminGetCourseDetailQueryKey({ path })
  return queryOptions<AdminGetCourseDetailStatus200, ResponseErrorConfig<AdminGetCourseDetailStatus422>, AdminGetCourseDetailStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return await adminGetCourseDetail({ ...config, path, signal: config.signal ?? signal, throwOnError: true })
   },
  })
}

/**
 * @summary Get Course
 * {@link /admin/course/:course_id}
 */
export function useAdminGetCourseDetail<TData = AdminGetCourseDetailStatus200, TQueryData = AdminGetCourseDetailStatus200, TQueryKey extends QueryKey = AdminGetCourseDetailQueryKey>({ path }: { path: AdminGetCourseDetailOptions['path'] | (() => AdminGetCourseDetailOptions['path']) }, options: {
  query?: Partial<QueryObserverOptions<AdminGetCourseDetailStatus200, ResponseErrorConfig<AdminGetCourseDetailStatus422>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { path: typeof path === 'function' ? path() : path }
  const queryKey = resolvedOptions?.queryKey ?? adminGetCourseDetailQueryKey(resolvedParams)

  const queryResult = useQuery({
   ...adminGetCourseDetailQueryOptions(resolvedParams, config),
   ...resolvedOptions,
   queryKey,
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AdminGetCourseDetailStatus422>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
